// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"187":"34480a8a","575":"647b2768","789":"0c68ff2d","800":"56c8b01b"}[chunkId] + ".chunk.css";
};